// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"272a4205","404":"d1c31f34","498":"f87f9b9d","550":"cdfd6a61"}[chunkId] + ".chunk.js";
};